import React, { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import store from 'Store';

import { retrieveData, loadLanguage, clearState } from 'Store/reducers/BillingReducer';
import { useRouteMatch } from 'react-router-dom';
import BemClass from '@upsales/components/Utils/bemClass';
import T from 'Components/Helpers/translate';
import { isCreditBulk } from 'App/services/prospectingService';
import './BillingRoot.scss';

const Billing = lazy(() => import('./Billing'));

export default class BillingRoot extends React.Component {
	constructor(props) {
		super(props);

		const languageObject = {
			none: T('none'),
			pleaseNote: T('default.pleaseNote'),
			pleaseNoteText: T('admin.billing.pleaseNoteText'),
			credits: T('mail.credits'),
			credit: T('soliditet.credit'),
			billing: T('admin.billing'),
			managePlan: T('admin.billing.managePlan'),
			pickPlan: T('admin.billing.pickPlan'),
			buyUpsales: T('admin.billing.buyUpsales'),
			cancelUpsales: T('admin.billing.cancelUpsales'),
			yourPlan: T('admin.billing.yourPlan'),
			amount: T('admin.billing.amount'),
			billingPeriod: T('admin.billing.billingPeriod'),
			nextBilling: T('admin.billing.nextBilling'),
			nextBillingAmount: T('admin.billing.nextBillingAmount'),
			monthlyCost: T('admin.billing.monthlyCost'),
			oneTimeCost: T('admin.billing.oneTimeCost'),
			licencesToAdd: T('admin.billing.licencesToAdd'),
			licenceCost: T('admin.billing.licenceCost'),
			licenceAgreement: T('admin.billing.licences.agreement'),
			licencesUsed: T('admin.billing.licences.used'),
			licence: T('default.licence'),
			licences: T('admin.licences'),
			contactsUsed: T('admin.billing.contacts.used'),
			subscription: T('agreement'),
			period: {
				month: T('admin.billing.period.month'),
				quarter: T('admin.billing.period.quarter'),
				halfyear: T('admin.billing.period.halfyear'),
				year: T('admin.billing.period.year')
			},
			addon: {
				upsales_tv: T('admin.billing.addon.upsalesTV'),
				extra_seats: T('admin.billing.addon.extraSeats'),
				extra_contacts: T('admin.billing.addon.extraContacts'),
				looker: T('admin.billing.addon.looker')
			},
			days: T('days'),
			trialPart1: T('admin.billing.trial.part1'),
			trialPart2: T('admin.billing.trial.part2'),
			trialPart3: T('admin.billing.trial.part3'),
			addSeats: T('admin.billing.addSeats'),
			addContacts: T('admin.billing.addContacts'),
			purchase: T('default.purchase'),
			confirmPurchase: T('default.confirmPurchase'),
			plan: T('admin.billing.plan'),
			activeAddons: T('admin.billing.activeAddons'),
			quantity: T('default.quantity'),
			price: T('default.price'),
			total: T('default.total'),
			totalCost: T('admin.billing.totalCost'),
			totalCost2: T('admin.billing.totalCost2'),
			costPerCredit: T('admin.billing.costPerCredit'),
			creditsToAdd: T('admin.billing.creditsToAdd'),
			creditsSmallestAmount: T('admin.billing.creditsSmallestAmount'),
			change: T('default.change'),

			download: T('landingpage.clickToDownload'),
			billingMethodHistory: T('admin.billing.billingMethodHistory'),
			billingMethod: T('admin.billing.billingMethod'),
			expires: T('default.expires'),
			date: T('default.date'),
			description: T('default.description'),
			type: T('default.type'),
			successful: T('default.successful'),
			failed: T('default.failed'),
			succeeded: T('default.succeeded'),
			charge: T('default.charge'),
			payment: T('default.payment'),
			adjustment: T('default.adjustment'),
			name: T('column.name'),
			payedAmount: T('admin.billing.payedAmount'),
			pastDue: T('admin.billing.pastDue'),
			current: T('admin.billing.current'),
			status: T('admin.billing.status'),
			incomingBalance: T('admin.billing.incomingBalance'),
			headerDescription: T('admin.billing.headerDescription'),
			addCredits: isCreditBulk() ? T('admin.billing.buyMoreCredits') : T('admin.billing.addCredits'),
			billingAddress: T('address.invoice'),
			sendInvoiceTo: T('admin.billing.invoiceSentTo'),
			prospecting: T('admin.prospecting'),
			month: T('date.month')
		};

		store.dispatch(clearState());
		store.dispatch(loadLanguage(languageObject));
		store.dispatch(retrieveData());
	}

	render() {
		return (
			<Suspense fallback={<div />}>
				<Provider store={store}>
					<Billing props={this.props} />
				</Provider>
			</Suspense>
		);
	}
}

const WrappedBillingRoot = props => {
	const classes = new BemClass('BillingRoot');

	return (
		<div className={classes.b()} id="admin" key={props?.initialTab}>
			<BillingRoot {...props} />
		</div>
	);
};

export const PortedAdminBilling = () => {
	const { params } = useRouteMatch();
	return <WrappedBillingRoot initialTab={params.initialTab} />;
};
